import axios from "axios";
import { getSessionId } from "../../../utils/tokenHandlers";
import UidEmailRoleMatch from "../../constants/uidEmailRoleMatch";

export const getIndividualDocs = async (
  customerId: number | null,
  selectedId: number | null,
) => {
  const UidEmailRole = UidEmailRoleMatch();

  const sessionId = getSessionId();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/read/many/tradexwbench.customer_key_person/`,
      {
        params: {
          ...UidEmailRole,
          filter: `[('customer_id', 'in',  [${customerId}]), ('id', '=', [${selectedId}])]`,
          query:
            "{id, customer_id, customer_key_person_document_ids{id, document_type, document_name, attachment_ids, document_name_text, maker_verification_status, checker_verification_status}, signed_digio_key_id, key_person_saf_maker_verification_status, key_person_saf_maker_verification_comments, key_person_saf_checker_verification_status, key_person_saf_checker_verification_comments}",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      },
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
